<template>
  <modal :title="i18n.t('/Configuration/OverwriteAccessoriesModal/Title')" :no-close-button="true">
    <p v-html="i18n.t('/Configuration/OverwriteAccessoriesModal/InfoText')"></p>
    <loader v-if="isLoading" />
    <template v-else>
      <app-button
        button-class="button primary"
        data-qa="keep-options-yes-button"
        @click="overwriteAccessories(false)"
      >
        {{ i18n.t('/Common/Yes') }}
      </app-button>
      <app-button
        button-class="button primary"
        data-qa="keep-options-no-button"
        @click="overwriteAccessories(true)"
      >
        {{ i18n.t('/Common/No') }}
      </app-button>
    </template>
  </modal>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'

export default {
  components: {
    AppButton,
    Modal,
    Loader,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['overwrite-accessories'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      configurationCode: '',
    }
  },
  computed: {},
  methods: {
    overwriteAccessories(overwrite) {
      this.$emit('overwrite-accessories', overwrite)
    },
  },
}
</script>

<style lang="scss" scoped></style>
